import { get, post } from '../store/apiClient';
import { CandidateResponse } from '../store/slices/jobAuth/JobAuthTypes';
import { formatUrl } from '../utils/urlFormatter';

// Endpoint path
const createCandidateLogin = '/candidate.login';
const verifyCandidateOtp = '/candidate.verifyOtp'


// post candidate


export const createCandidateLoginFlow = async (data: any): Promise<CandidateResponse> => {
  const endpoint = formatUrl(createCandidateLogin, []);
  return post<CandidateResponse>(endpoint, data);
};


export const verifyCandidateOtpFlow = async (data: any): Promise<CandidateResponse> => {
  const endpoint = formatUrl(verifyCandidateOtp, []);
  return post<CandidateResponse>(endpoint, data);
};